module.exports = __webpack_public_path__ + "static/media/a5.64fa3d08.jpg";